/*
 * 电影
 * */
import request from "@utils/request";

/*
 * 跳转到电影页面 加密uid、phone
 * */
export function encryptedInformation(data) {
    return request.get("/movieLogin", data);
}

/*
 * 跳转到轩夸电影页面 加密uid、phone
 * */
export function xuankuaLoginSign(data){
    return request.get("/xuankuaLoginSign",data)
    }

/*
 * 电影页面跳转到支付页面 解密sign
 * */
export function decryptionInformation(data) {
    return request.post("/order/orderLogin", data, {login: false})
}

/*
轩夸电影页面跳转到支付页面
*/
export function orderXuankuaPaying(data,id){
    return request.post(`/order/xuankuaPaying&tradeno=${data}&uid=${id}`,{login:false})
}

/*
轩夸电影支付接口
*/
export function orderMoviexkPay(uni, paytype, from,tradeno, coupon_id=null) {
    return request.post("/order/moviexkPay", { uni, paytype, from,tradeno, coupon_id });
}

/*
轩夸演出订单详情接口
*/
export function xuankuaycPaying(data,id){
    return request.post(`/order/xuankuaycPaying&tradeno=${data}&uid=${id}`,{login:false})
}

/*
轩夸演出支付接口
*/
export function orderXkYcPayment(uni, paytype, from,tradeno, coupon_id=null) {
    return request.post("/order/moviexkycPay", { uni, paytype, from,tradeno, coupon_id });
}

/****
 * 轩夸演出订单列表
 */
export function getXkYcOrderList(data) {
    return request.get("/order/movieyclist", data);
}

/****
 * 轩夸演出订单详情
 */
export function getXkYcOrderDetail(id) {
    return request.get("/order/movieycDetail/" + id);
}


/*
 * 
 获取轩夸演出订单信息:累计、待付款、已完成
 * */
 export function getXkYcOrderData() {
    return request.get("/order/movieDatayc");
}

/*
* main.js 登录
* */
export function loginOrderInformation(data) {
    return request.post("/order/loginOrder", data, {login: false})
}


/*
 * 我的优惠券
 * */
export function getCouponsUser(type,types) {
    return request.get("/coupons/user/" + type+'/'+types,{}, {login: false});
}


/*
 * 获取电影订单列表
   type 1=待付款 2=已完成 3=全部订单
   page 1
   limit 20
   http://test.xiaojiangwh.com/api/order/movielist?page=1&limit=20&type=3
 * */
export function getMovieOrderList(data) {
    return request.get("/order/movielist", data);
}

/*
 * 
 获取订单信息:累计、待付款、已完成
 * */
export function getMovieOrderData() {
    return request.get("/order/movieData");
}


/*PR
 * 支付
 * */
export function payMovieOrder(uni, paytype, from, coupon_id=null) {
    return request.post("/order/moviePay", { uni, paytype, from, coupon_id });
}


/*
 * MovieTicketDetails
 电影票信息
 * */
export function movieOrderDetail(id) {
    return request.get("/order/movieDetail/" + id);
}



